// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2RYun","close":"Header_close__14q2E","body":"Header_body__kBbFU"};